<template>
  <el-dialog
    :title="title"
    width="fit-content"
    @close="handleClose"
    :modal-style="{ maxWidth: '90%' }"
    :visible.sync="internalVisible"
    :modal-class="'custom-dialog'"
  >
    <slot></slot>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Hủy</el-button>
      <el-button type="primary" @click="handleConfirm">Xác nhận</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'PopupDialog',
  props: {
    title: {
      type: String,
      default: 'Thông báo',
    },
    autoClose: {
      type: Boolean,
      default: true, // tự động đóng sau khi chạy confirm/close
    }
  },
  data() {
    return {
      internalVisible: true,
    };
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm', () => {
        if (this.autoClose) this.closeDialog();
      });
      // if (this.autoClose) this.closeDialog();
    },
    handleClose() {
      this.$emit('close',() => {
        if (this.autoClose) this.closeDialog();
      });
      // if (this.autoClose) this.closeDialog();
    },
    closeDialog() {
      this.internalVisible = false;
    },
    autoCloseCallback() {
      this.closeDialog();
    }
  }
};
</script>
<style scoped>
.custom-dialog .el-dialog {
  max-height: 80vh; /* hoặc px */
  overflow-y: auto;
}
</style>